import Vue from 'vue';
import VueRouter from 'vue-router';
import {publicRouter} from "@/router/publicRouter";
import {authorizationRouter} from "@/router/authorizationRouter";
import store from '@/store/index';
import {administrationRouter} from "@/router/administrationRouter";
import {dashboardRouter} from "@/router/dashboardRouter";
import {projectRouter} from "@/router/projectRouter";
Vue.use(VueRouter);

const routes = [
                ...publicRouter,
                ...authorizationRouter,
                ...administrationRouter,
                ...dashboardRouter,
                ...projectRouter
               ];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next();
            return
        }
        next('/login');
    } else {
        next();
    }
});

export default router;
